'use strict'


$(function() {
    let isInitSlickSlider = false;

    $('.js-menu-opener').menuOpener();
    $('.js-reel-video').reelVideo();
    $('.js-menu').menu();

    if ($('.js-preview-item').length) {
      $('.js-preview-item').previewVideo();
    }
    if ($('.js-fixed-player').length) {
      $('.js-fixed-player').fixedPlayer();
    }
    if ($('.js-gallery-grid').length) {
      $('.js-gallery-grid').galleryGrid();
    }
    $(window).scroller();

    if ($('body').hasClass('default')) {
        $(window).headScroller();
    }

    function pushReel() {
        if (window.matchMedia('only screen and (max-width: 900px)').matches) {
            let height = 0;

            height += $('.js-header-logo').outerHeight();
            height += $('.js-menu-opener-wrapper').outerHeight();

            if ($('body').hasClass('project')) {
                $('main').css({
                    marginTop: height
                });
            }
            $('.js-header').addClass('is-sticky');
        }
    }

    function initSlickSlider() {
        if (isInitSlickSlider === false) {
            $('.js-slick-slider').slickSlider();
            isInitSlickSlider = true;
        }
        else {
            $(window).off('resize', initSlickSlider);
        }
    }

    function measureHeader() {
        window.headerHeight = $('.js-header').outerHeight();
    }
    measureHeader();

    $(window).on('resize', measureHeader);


    if (window.matchMedia) {
        pushReel();
        initSlickSlider();

        $(window).on('resize', pushReel);
        $(window).on('resize', initSlickSlider);
    }


    // Check location hash und set header scroll position
    // const locationHash = document.location.hash;
    // if (locationHash.length > 1) {
    //     const scrollTop = $('html').scrollTop();
    //     window.scrollTo({
    //         top: scrollTop - 1,
    //         behavior: 'smooth',
    //     }, 10, function() {
    //       window.scrollTo({
    //         top: scrollTop,
    //         behavior: 'smooth',
    //       }, 10);
    //     });
    // }


    // Project Slider
    $('.project-slider .icon').on('mouseenter', function() {
        $(this).parent().find('._text-link').addClass('hover');
    });

    $('.project-slider .icon').on('mouseleave', function() {
        $(this).parent().find('._text-link').removeClass('hover');
    });


    // Lozad
    const el = document.querySelectorAll('[data-lozad]');
    const observer = lozad(el, {
      rootMargin: '300px 0px'
    });
    observer.observe();
});
